module.exports = __webpack_public_path__ + "media/images/ui__textArrowRight--dark-4b9bedcc445852b790a6a22fe8cb6c44.png";